
export default {
    data() {
        return {
            mode: 'login',
            isLoading: false,
            // inputs
            userMail: '',
            userPassword: '',

            // inputs rules
            emailRules: [
                (val: string) => !!(val && val.trim()) || this.$t('auth.inputs.errors.fieldRequired'),
                (val: string) =>
                    !(val && val.trim()) || /.+@.+\..+/.test(val) || this.$t('auth.inputs.errors.emailInvalid')
            ],
            passwordRules: [(val: string) => !!(val && val.trim()) || this.$t('auth.inputs.errors.fieldRequired')]
        };
    },
    computed: {
        submitButtonCaption() {
            return this.mode === 'login' ? this.$t('auth.buttons.login') : this.$t('auth.buttons.signUp');
        },
        switchModeButtonCaption() {
            return this.mode === 'login' ? this.$t('auth.buttons.signUpInstead') : this.$t('auth.buttons.loginInstead');
        },
        hasEnteredData() {
            return !!this.userMail && !!this.userPassword;
        }
    },
    methods: {
        async submitData() {
            const { valid } = await this.$refs.form.validate();
            if (!valid) return;

            this.isLoading = true;

            const actionPayload = { email: this.userMail, password: this.userPassword };
            try {
                let message;
                if (this.mode === 'login') {
                    message = await this.$store.dispatch('login', actionPayload);
                    this.$router.replace('/');
                } else {
                    message = await this.$store.dispatch('signUp', actionPayload);
                    this.mode = 'onboarding';
                }
                this.$store.dispatch('snackbar/showSnackbar', { message, type: 'success' });
            } catch (error) {
                this.$store.dispatch('snackbar/showSnackbar', { message: error.message, type: 'failure' });
            }

            this.isLoading = false;
        },
        switchAuthMode() {
            this.mode = this.mode === 'login' ? 'signUp' : 'login';
        },
        async addDefaultContacts() {
            this.isLoading = true;

            await this.$store.dispatch('contacts/setDefaultContacts');
            this.$router.replace('/');

            this.isLoading = false;
        }
    }
};
